import React from "react";
import "../css/BottomSheet.css";

interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  height?: string;
}

const BottomSheet: React.FC<BottomSheetProps> = ({
  open,
  onClose,
  children,
  height = "50dvh",
}) => {
  return (
    <>
      <div
        className={`bottom-sheet-overlay ${open ? "show" : ""}`}
        onClick={onClose}
      />

      <div
        className={`bottom-sheet-container ${open ? "open" : ""}`}
        style={{ height }}
      >
        {children}
      </div>
    </>
  );
};

export default BottomSheet;
